export default {
    _nulshockbold: 'nulshockbold',
    _nokioregular: 'nokioregular',
    _nokiolight: 'nokiolight',
}